module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('page-wrapper', {
    attrs: {
      "background": "/static/img/anniversary/page-activities/bg.png",
      "swiper": _vm.swiper,
      "hasDownBtn": true
    }
  }, [_c('div', {
    staticClass: "main-text ani",
    attrs: {
      "swiper-animate-effect": "animate__fadeIn"
    }
  }, [_vm._v("\n    近些年"), _c('br'), _vm._v("吉凯每个月都会定期举办丰富多彩的"), _c('br'), _vm._v("市场活动"), _c('br'), _vm._v("您一共参加过"), _c('span', {
    staticClass: "text-highline"
  }, [_vm._v(_vm._s(_vm.data.campaignTimes))]), _vm._v("活动\n  ")]), _vm._v(" "), (_vm.activities.length > 0) ? _c('div', {
    staticClass: "main-text-2 ani",
    attrs: {
      "swiper-animate-effect": "animate__fadeIn"
    }
  }, [_vm._v("\n    2024年之前 您参加了\n    "), _vm._l(([0, 1, 2]), function(i) {
    return _c('p', {
      key: i,
      staticClass: "activities-list"
    }, [_vm._v(_vm._s(_vm.activities[i]))])
  }), _vm._v(" "), _c('p', {
    staticClass: "activities-list"
  }, [_vm._v(_vm._s(_vm.activities.length > 3 ? '...' : ''))])], 2) : _vm._e(), _vm._v(" "), (_vm.activitiesThisYear.length > 0) ? _c('div', {
    staticClass: "main-text-3 ani",
    attrs: {
      "swiper-animate-effect": "animate__fadeIn"
    }
  }, [_vm._v("\n    今年您参加了\n    "), _vm._l(([0, 1, 2]), function(i) {
    return _c('p', {
      key: i,
      staticClass: "activities-list"
    }, [_vm._v(_vm._s(_vm.activitiesThisYear[i]))])
  }), _vm._v(" "), _c('p', {
    staticClass: "activities-list"
  }, [_vm._v(_vm._s(_vm.activitiesThisYear.length > 3 ? '...' : ''))])], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ef69dde","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Anniversary/PageActivities/index.vue
// module id = 1630
// module chunks = 8